<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpText
    :muted="payload.inactive"
    :strikethrough="payload.inactive"
    elName="DIV"
  >
    <ItpIcon
      :name="payload.account_type === 'cash_book' ? $config.account.cashBook.icon : $config.account.bankAccount.icon"
      class="pr-1"
    >
    </ItpIcon>
    <strong
      class="pr-1"
      v-if="displayOwner && ownerCode"
    >
      {{ ownerCode }} - 
    </strong>
    <span
      class="text-truncate"
    >
      <strong>{{ payload.name }}</strong> ({{ payload.currency }}) {{ payload.bank || '' }}
    </span>
  </ItpText>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcAccountSelectOption extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  payload!: object;

  @Watch('payload')
  onPayload(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("payload")
  }

  @Prop({
    type: Boolean,
  })
  displayOwner!: boolean;

  @Watch('displayOwner')
  onDisplay_owner(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("displayOwner")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  get ownerCode() {
    if (this.loaded) {

      return this.payload.owner ? this.payload.owner.code : this.payload.owner_code
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_6300: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_6299: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_6300 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_6299 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_6300,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_6299],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_6300,
      evh_7315092382398562_reload_6299,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("UcAccountSelectOption", UcAccountSelectOption);

</script>